export default __webpack_public_path__ + "static/media/MALNADs.6667446d.png";